import { useState, useEffect } from 'react';

const cache = {};

export function useWatchPrice(watch) {
  const [price, setPrice]        = useState(watch.market);
  const [loading, setLoading]    = useState(true);
  const [source, setSource]      = useState('static');
  const [sampleSize, setSample]  = useState(null);

  useEffect(() => {
    if (!watch) return;
    const key = watch.id;

    if (cache[key]) {
      setPrice(cache[key].market);
      setSource(cache[key].source);
      setSample(cache[key].sampleSize || null);
      setLoading(false);
      return;
    }

    const base = process.env.REACT_APP_API_URL || '';
    const params = new URLSearchParams({
      watchId: watch.id,
      ref:     watch.ref   || '',
      brand:   watch.brand || '',
      model:   watch.model || '',
    });

    fetch(`${base}/.netlify/functions/watch-price?${params}`)
      .then(r => r.json())
      .then(data => {
        if (data.market) {
          // Sanity check — scraped price must be within 60% of static market price
          // This prevents a $150,000 watch returning $15,000 due to parsing error
          const staticMkt = watch.market;
          const scraped = Number(data.market);
          const ratio = scraped / staticMkt;
          const sane = ratio >= 0.35 && ratio <= 3.0;
          const finalPrice = sane ? scraped : staticMkt;
          const finalSource = sane ? (data.source || 'static') : 'static';
          cache[key] = { ...data, market: finalPrice, source: finalSource };
          setPrice(finalPrice);
          setSource(finalSource);
          setSample(sane ? (data.sampleSize || null) : null);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [watch]);

  return { price, loading, source, sampleSize };
}
